import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { ConnectionStatus, Network } from '@capacitor/network';
import { BehaviorSubject, pairwise } from 'rxjs';

@Component({
    selector: 'app-root',
    template: `
    <div *ngIf="showLoading" class="vh-100 vw-100 d-flex justify-content-center align-content-center" [appLoadingOverlay]="true"></div>
    <router-outlet (activate)="showLoading = false"></router-outlet>
  `,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'versacommerce-pos';
  showLoading = true;

  private connectedStatusChange = new BehaviorSubject<boolean>(true);

  constructor(private readonly router: Router, private readonly zone: NgZone) {}

  ngOnInit(): void {
    this.connectedStatusChange.pipe(
      pairwise()
    ).subscribe(([wasConnected, isConnected]) => {
      let navigationPath = '';
      if (wasConnected && !isConnected) {
        navigationPath = 'network-error';
      } else if (!wasConnected && isConnected) {
        navigationPath = '/';
      }

      if (navigationPath) {
        this.zone.run(() => {
          this.router.navigateByUrl(navigationPath);
        });
      }
    });

    Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      this.connectedStatusChange.next(status.connected);
    });
  }

  ngOnDestroy(): void {
    App.removeAllListeners();
  }
}
